import { Button, Form, Input, Space } from 'antd';
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import loginbig from '../../Images/loginimg.jpg';
import logincl1 from '../../Images/login-cl-1.png';
import logincl2 from '../../Images/login-cl-2.png';
import logincl3 from '../../Images/login-cl-3.png';
import logincl4 from '../../Images/login-cl-4.png';
import logincl5 from '../../Images/login-cl-5.png';
import logo from '../../Images/logo-white.svg';
import logow from '../../Images/logo.svg';
import { ReactComponent as Email } from "../../Images/Email.svg";
function ForgetPassword() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const initialState = {
        email: '',
        password: '',
    };
    const [state, setState] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const emailInputRef = useRef();

    const onChange = e => {
        let { value } = e.target;
        setState({
            ...state,
            email: value,
        });
    };
    const handleSubmit = (values) => {

        setLoading(true);
    };

    return (
        <>
            <section className="Login-Form-Page">
                <div className="loginleft">
                    <div className='leftinside'>
                        <div className="formContent">
                            <div className="logow">
                                <img
                                    className="NavLogo"
                                    src={logow}
                                    alt=""
                                ></img>
                            </div>
                            <div className="title">
                                <h3>Forgot Password</h3>
                                <h6>Enter your registered email address and we will send you a link to reset your password</h6>
                            </div>

                            <Form
                                form={form}
                                onFinish={handleSubmit}
                                autoComplete="off"
                                layout="vertical"
                            >
                                <Form.Item
                                    name="email"
                                    label="Email"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter a valid email or username!',
                                        },
                                        {
                                            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                            message: 'Please enter a valid email address!',
                                        },
                                    ]}
                                >
                                    <Input
                                    prefix={<Email />}
                                        placeholder="Enter Email"
                                        onChange={onChange}
                                        ref={emailInputRef}
                                    />
                                </Form.Item>

                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                    <Button type="link" color="default" variant="filled" onClick={async () => { navigate('/login'); }} >
                                        Cancel
                                    </Button>
                                    <Button type="primary" htmlType="submit" loading={loading}>
                                        Send
                                    </Button>

                                </div>
                            </Form>

                        </div>

                    </div>
                    <div className="loginfooter">
                        <div className="links">
                            <Space>
                                <a href="https://aluxerp.com/privacy-policy" target='_blank'>Privacy Policy</a> | <a href="https://aluxerp.com/terms-and-condition" target='_blank'>Terms & Conditions</a> |{' '}
                                <a href="https://aluxerp.com/contact" target='_blank'>
                                    Contact
                                </a>
                            </Space>
                        </div>


                        <div className="colpyr">
                            <p>
                                Copyright&copy; {(new Date().getFullYear())}{' '}
                                <a href="https://nivzen.com/" target='_blank'>Nivzen Technologies</a> All rights reserved.
                            </p>
                        </div>
                    </div>
                </div>

            
            <div className="loginright">

                <div className="logincont">
                    <div className="logod">
                        <img
                            className="NavLogo"
                            src={logo}
                            alt=""
                        ></img>
                    </div>
                    <h3>
                        Experience Next-Level Business Efficiency
                    </h3>
                    <p>
                        Embrace efficiency and transparency for business success. Our solutions empower you to operate effectively, communicate transparently, and achieve your goals. Join us and transform your business today.
                    </p>

                </div>


            </div>


        </section >
        </>
    );
}

export default ForgetPassword;
